/* eslint-disable */
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  TextField,
  Tooltip,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";

const initialState = {
  tipo: "",
  numero: "",
};

const tableColumns = (handleObtieneDocumento) => [
  {
    name: "id",
    label: "ID",
    options: {
      filter: false,
      sort: false,
      display: "excluded",
    },
  },
  {
    name: "tipo",
    label: "Tipo de Documento",
    options: {
      filter: false,
      sort: false,
    },
    setCellProps: () => ({
      style: {
        textAlign: 'center',
      },
    }),
    setCellHeaderProps: () => ({
      style: {
        textAlign: 'center',
      },
    })

  },
  {
    name: "numero",
    label: "Número de Documento",
    options: {
      filter: false,
      sort: false,
    },
    setCellProps: () => ({
      style: {
        textAlign: 'center',
      },
    }),
    setCellHeaderProps: () => ({
      style: {
        textAlign: 'center',
      },
    }),

  },
  {
    name: "actions",
    label: "Acciones",
    options: {
      filter: false,
      sort: false,
      empty: true,
      setCellProps: () => ({
        style: {
          textAlign: 'center',
        },
      }),
      setCellHeaderProps: () => ({
        style: {
          textAlign: 'center',
        },
      }),
      customBodyRenderLite: (dataIndex) => (
        <>
          <Tooltip title="Ver Documento">
            <IconButton
              size="small"
              aria-label="view"
              onClick={() => handleObtieneDocumento(dataIndex)}
            >
              <RemoveRedEyeOutlinedIcon />
            </IconButton>
          </Tooltip>
        </>
      ),
    },
  },
];

const tableOptions = {
  download: false,
  filter: false,
  print: false,
  search: false,
  viewColumns: false,
  pagination: false,
  elevation: 1,
  selectableRows: "none",
  textLabels: {
    body: {
      noMatch: "No se encontraron registros",
    },
  },
};

const nameItemText = "Documentos";
const itemGender = "M";

const DocumentosDialog = ({
  onSave,
  onClose,
  itemCrud,
  itemsCrud,
  actionCrud,
  setMessage,
  setShowMessage
}) => {
  const [itemCrudLocal, setItemCrudLocal] = useState(initialState);
  const [documentos, setDocumentos] = useState([]);

  useEffect(() => {
    if (actionCrud === "create") {
      setItemCrudLocal(initialState);
    } else {
      setItemCrudLocal(itemCrud);
    }
    let _itemCrud = itemCrud;
    _itemCrud = itemCrud
    _itemCrud.forEach((item) => {
      item.tipo = item.tipo.toUpperCase();
    });
    setDocumentos(_itemCrud);

  }, [actionCrud, itemCrud, itemsCrud]);

  const handleObtieneDocumento = (dataIndex) => {
    const selectedDocument = documentos[dataIndex];
    setItemCrudLocal({
      tipo: selectedDocument.tipo,
      numero: selectedDocument.numero,
    });

  };

  const handleCloseDialog = () => {
    onClose();
  };

  const handleChange = (e) => {
    setItemCrudLocal({
      ...itemCrudLocal,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };

  const handleSave = () => {
    if (itemCrudLocal.tipo === "" || itemCrudLocal.numero === "") {
      setMessage({
        severity: "error",
        messageText: "Debes completar todos los campos.",
      });
      setShowMessage(true);
      return;
    }
    save();
  };

  const save = async () => {
    const _itemCrud = {
      id: _idDocumento,
      tipo: itemCrudLocal.tipo,
      numero: itemCrudLocal.numero,
    };

    // const response = await saveDocumento(actionCrud, _itemCrud); 

    if (response.ok) {
      onSave();
    }

    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    });
    setShowMessage(true);
  };

  return (
    <Dialog
      open={true}
      onClose={handleCloseDialog}
      maxWidth="md"
      fullWidth={true}
      scroll="paper"
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">
        {actionCrud === "view" ? "Ver" : "Nuevo"} {nameItemText}
        <IconButton
          aria-label="close"
          onClick={handleCloseDialog}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Box sx={{ m: 1, p: 1 }}>

          <Grid container spacing={2}>
            {(actionCrud === "view" || actionCrud === "delete") && (
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  sx={{ mb: 1, width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                    readOnly: actionCrud === 'view'
                  }}
                  id="tipo"
                  label="Tipo de Documento"
                  variant="outlined"
                  size="small"
                  name="tipo"
                  value={itemCrudLocal.tipo?.toUpperCase() || ""}
                  onChange={handleChange}
                />
              </Grid>
            )}
            {(actionCrud === "edit" || actionCrud === "new") && (
              <Grid item xs={12} md={6} lg={4}>
                <FormControl fullWidth sx={{ mb: 1 }}>
                  <Autocomplete
                    id="tipo"
                    options={documentos.map((doc) => doc.tipo)}
                    isOptionEqualToValue={(option, value) =>
                      option.toUpperCase() === value.toUpperCase()
                    }
                    getOptionLabel={(option) => option.toUpperCase()}
                    value={itemCrudLocal.tipo?.toUpperCase() || null}
                    onChange={(event, newValue) => {
                      handleChange({
                        target: {
                          name: "tipo",
                          value: newValue || "",
                        },
                      });
                    }}
                    disabled={actionCrud === "view"}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Tipo de Documento"
                        size="small"
                      />
                    )}
                    ListboxProps={{ style: { maxHeight: "300px" } }}
                  />
                </FormControl>
              </Grid>
            )}
            <Grid item xs={3} lg={3}>
              <TextField
                fullWidth
                sx={{ mb: 1 }}
                inputProps={{
                  autoComplete: "off",
                  readOnly: actionCrud === 'view'
                }}
                id="numero"
                label="Número de Documento"
                variant="outlined"
                size="small"
                name="numero"
                value={itemCrudLocal.numero}
                onChange={handleChange}
              />
            </Grid>
          </Grid>
        </Box>

        <MUIDataTable
          title={"Listado de Documentos"}
          columns={tableColumns(handleObtieneDocumento)}
          options={tableOptions}
          data={documentos}
        />
        <Box sx={{ textAlign: "right", mb: 2, mt: 2 }}>
          {actionCrud !== "view" && (
            <Button
              sx={{ mr: 1 }}
              variant="contained"
              onClick={handleSave}
              startIcon={<SaveIcon />}
            >
              Guardar
            </Button>
          )}
          <Button sx={{ mr: 1 }} variant="outlined" onClick={handleCloseDialog}>
            {actionCrud === "view" ? "Volver" : "Cancelar"}
          </Button>
        </Box>
      </DialogContent>


    </Dialog>
  );
};

export default DocumentosDialog;
